import { Component, OnInit, Input } from '@angular/core';
import { AuditService } from '../../shared/services/audit.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audit-form',
  templateUrl: './audit-form.component.html',
  styleUrls: ['./audit-form.component.scss']
})
export class AuditFormComponent implements OnInit {

  @Input() formName: string = '';
  @Input() caseId: number;
  @Input() itemId: number;
  auditFormItems: any []= [];

  displayedColumns: string[] = ['fieldName', 'oldValue', 'newValue', 'byUser', 'dateChanged'];

  constructor(
  public activeModal: NgbActiveModal,
  private auditService: AuditService) {

  }

  ngOnInit(): void {
      if(this.caseId != null && this.caseId > 0)
    {
      this.auditService.getAuditItemsForCaseForm( this.formName, this.caseId ).subscribe((response: any)=>{

        this.auditFormItems = response;

        //[{"fieldName":"solarPanelsCompany","oldValue":"test","newValue":"Hello There","byUser":"Lisa Rich","dateChanged":"28-07-2021 21:26:19"}]

      });
    }
    else{
      this.auditService.getAuditItemsForForm( this.formName, this.itemId ).subscribe((response: any)=>{

        this.auditFormItems = response;

      });
    }
  }

}
